/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Flex, Space, Text } from '@sonyged/proc-ui';
import { css } from '@styled-system/css';

import { ContentScroll } from '../../../../../common/components/ContentScroll';
import type { Customer } from '../../../../../sushi/rules/types';
import { StatTable } from './StatTable';
import { getSushiColor, heatColorLevel, heatmapData } from './constant';
import SushiArrow from '../../../../../assets/images/pages/sushi/sushi_field_data_arrow@3x.png';

type Props = {
  customer: Customer,
};

export function HeatMap(props: Props) {
  let { customer } = props;
  return (
    <ContentScroll flex={1} minHeight={0} gradientHeight={12}>
      <Space mb={[3, 3, 7]}>
        <ColorPalette>
          <ColorPaletteHeading>表の色わけ</ColorPaletteHeading>
          {Array(6)
            .fill()
            .map((_, index) => (
              <ColorPaletteItem key={index} style={{ backgroundColor: heatColorLevel[index] }} />
            ))}
        </ColorPalette>
      </Space>

      <Space mb={[6, 6, 16]}>
        <ColorPaletteTitle>
          <span>少</span>
          <Arrow src={SushiArrow} alt="arrow" />
          <span>多</span>
        </ColorPaletteTitle>
      </Space>

      <StatTable>
        <HeatmapHeader>
          <tr>
            <th style={{ width: '30%' }} />
            <th>1皿目</th>
            <th>2皿目</th>
            <th>3皿目</th>
            <th>4皿目</th>
            <th>5皿目</th>
          </tr>
        </HeatmapHeader>
        <HeatmapBody>
          {heatmapData[customer.gender][customer.ageGroup].map((sushi2, i) => (
            <tr key={i}>
              <td>{sushi2.sushiName}</td>
              {sushi2.data.map((value, j) => (
                <td
                  style={{
                    backgroundColor: getSushiColor(value),
                  }}
                  key={j}
                />
              ))}
            </tr>
          ))}
        </HeatmapBody>
      </StatTable>
    </ContentScroll>
  );
}

const HeatmapHeader = styled('thead')(
  css({
    th: {
      py: [4, 4, 6],
    },
  })
);

const HeatmapBody = styled('tbody')(
  css({
    td: {
      px: [12, 12, 16],
      py: [4, 4, 8],
      color: 'secondary100',
    },
  })
);

const ColorPalette = styled(Flex)(
  css({
    justifyContent: 'flex-end',
    alignItems: 'center',
  })
);

const ColorPaletteHeading = styled(Text)(
  css({
    color: '#fff',
    mr: [12, 12, 16],
    lineHeight: 'title',
    fontSize: [13, 13, 20],
  })
);

const ColorPaletteTitle = styled(Flex)(
  css({
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: [13, 13, 25],
    color: '#fff',
  })
);

const Arrow = styled('img')(
  css({
    width: [168, 168, 252],
    height: [16, 16, 24],
  })
);

const ColorPaletteItem = styled('div')(
  css({
    width: [28, 28, 50],
    height: [18, 18, 30],
  })
);
